module.exports = __webpack_public_path__ + "media/images/common/new_entry_btn-1b1a86c8b7bc9bfd3a1a42f65fa6167c.gif";